<div
  [formGroup]="form"
  class="py-2 px-6 items-center"
>
  <div class="flex justify-between items-center -mx-2 gap-4">
    <mat-form-field class="input-tg mt-message-input no-message-new w-2/12" appearance="outline">
      <mat-label>Tipo Serviço</mat-label>
      <mat-select formControlName="typeService">
        @for (type of listType; track type) {
          <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="input-tg mt-message-input no-message-new w-10/12" appearance="outline">
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
  </div>
  <div class="flex items-center -mx-2 gap-4">
    <mat-form-field class="input-tg mt-message-input w-2/12" appearance="outline">
      <mat-label>Carga horária</mat-label>
      @if (form.get('hour')!.value != '') {
        <span matTextSuffix>Hora(s)</span>
      }
      <input matInput integerInput formControlName="hour" />
    </mat-form-field>
    <mat-form-field class="input-tg mt-message-input w-2/12" appearance="outline">
      <mat-label>Quilometragem</mat-label>
      @if (form.get('km')!.value != '') {
        <span matTextSuffix>Km</span>
      }
      <input matInput currencyInput formControlName="km" />
    </mat-form-field>
    <mat-slide-toggle
      class="input-tg mt-message-input w-2/12 p-bottom-toggle"
      formControlName="vehicle"
    >
      Exige veículo
      <u>{{ form.get('vehicle')?.value ? 'sim' : 'não' }}</u></mat-slide-toggle
    >
  </div>
  <div class="flex justify-end items-center -mx-2 mb-3">
  <button
    mat-flat-button
    class="btn-tg w-2/12"
    [disabled]="form.invalid || loading"
    (click)="createItem()"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Adicionar
    }
  </button>
  </div>
  <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
</div>
